// import React, { useEffect, useState } from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   IconButton,
//   Popover,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Box,
// } from "@mui/material";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchThingDetails } from "features/thing/thingThunk";
// import {
//   setModelThing,
//   setModalVisible,
//   setCheckData,
// } from "features/planning/planningSlice";

// function PlanningTable() {
//   const dispatch = useDispatch();

//   const things = useSelector((state) => state.things.things);
//   const modalVisible = useSelector((state) => state.planning.modalVisible);

//   // filter popover
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [deviceFilter, setDeviceFilter] = useState({
//     enabled: false,
//     disabled: false,
//     noDevice: false,
//   });

//   // Sorting state
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: "asc", 
//   });

//   const open = Boolean(anchorEl);

//   useEffect(() => {
//     dispatch(fetchThingDetails());
//   }, [dispatch]);

//   const handleAssingnVehicle = (val) => {
//     if (val.tempThing) {
//       dispatch(setCheckData(true));
//     } else {
//       dispatch(setCheckData(false));
//     }
//     dispatch(setModalVisible(true));
//     dispatch(setModelThing(val));
//   };

//   // Sorting Handler
//   const handleSort = (key) => {
//     let direction = "asc";
//     if (sortConfig.key === key && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key, direction });
//   };

//   // FILTERED DATA
//   const filteredThings = things.filter((row) => {
//     if (!deviceFilter.enabled && !deviceFilter.disabled && !deviceFilter.noDevice) {
//       return true;
//     }

//     const status =
//       (row.tempThing || row.tempThingFor) && row.devices === null
//         ? "disabled"
//         : row.devices === null
//           ? "noDevice"
//           : "enabled";

//     if (deviceFilter.enabled && status === "enabled") return true;
//     if (deviceFilter.disabled && status === "disabled") return true;
//     if (deviceFilter.noDevice && status === "noDevice") return true;

//     return false;
//   });

//   // SORTED DATA 
//   const sortedAndFilteredThings = [...filteredThings].sort((a, b) => {
//     if (!sortConfig.key) return 0;

//     const valA = a[sortConfig.key] ? a[sortConfig.key].toString().toLowerCase() : "";
//     const valB = b[sortConfig.key] ? b[sortConfig.key].toString().toLowerCase() : "";

//     if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
//     if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
//     return 0;
//   });

//   // Custom Icon Renderer function - (onClick Moved Here)
//   const renderSortIcons = (columnKey) => {
//     const isActive = sortConfig.key === columnKey;
//     const isAsc = isActive && sortConfig.direction === "asc";
//     const isDesc = isActive && sortConfig.direction === "desc";

//     return (
//       <Box 
//         onClick={() => handleSort(columnKey)} // Click sirf yaha kaam karega
//         sx={{ 
//           display: "flex", 
//           flexDirection: "column", 
//           ml: 0.5,
//           cursor: "pointer" // Cursor sirf icon par pointer banega
//         }}
//       >
//         <ArrowDropUpIcon
//           sx={{
//             fontSize: 20, 
//             mb: -1.3,     
//             color: isAsc ? "#1976d2" : "#c4c4c4", 
//             transition: "color 0.2s"
//           }}
//         />
//         <ArrowDropDownIcon
//           sx={{
//             fontSize: 20,
//             color: isDesc ? "#1976d2" : "#c4c4c4",
//             transition: "color 0.2s"
//           }}
//         />
//       </Box>
//     );
//   };

//   return (
//     <Paper
//       sx={{
//         mx: "auto",
//         borderRadius: 2,
//         overflow: "hidden",
//         boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
//       }}
//     >
//       {/* <MDBox
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         p={3}
//         borderBottom="1px solid #eee"
//       >
//         <MDTypography variant="h5" fontWeight="bold" color="text.primary">
//           Planning Table
//         </MDTypography>
//       </MDBox> */}

//       <TableContainer>
//         <Table>
//           <TableHead sx={{ display: "table-header-group" }}>
//             <TableRow>
              
//               {/* SORTABLE: Vehicle No. (Removed onClick from TableCell) */}
//               <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
//                 <Box display="flex" alignItems="center">
//                   VEHICLE NO.
//                   {renderSortIcons("thingId")}
//                 </Box>
//               </TableCell>

//               {/* SORTABLE: Vehicle Name (Removed onClick from TableCell) */}
//               <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
//                 <Box display="flex" alignItems="center">
//                   VEHICLE NAME
//                   {renderSortIcons("nickName")}
//                 </Box>
//               </TableCell>

//               <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
//                 <MDBox display="flex" alignItems="center">
//                   DEVICE STATUS
//                   <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
//                     <FilterListIcon fontSize="small" />
//                   </IconButton>
//                 </MDBox>
//               </TableCell>

//               <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
//                 REPLACED VEHICLE NO.
//               </TableCell>
//               <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
//                 REPLACED VEHICLE NAME
//               </TableCell>
//               <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
//                 ACTION
//               </TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {sortedAndFilteredThings.length > 0 ? (
//               sortedAndFilteredThings.map((row, idx) => (
//                 <TableRow key={idx} sx={{ "&:hover": { backgroundColor: "#fafafa" }, transition: "all 0.2s ease" }}>
//                   <TableCell>
//                     <Typography variant="body2">{row.thingId}</Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Typography variant="body2">{row.nickName}</Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         color:
//                           (row.tempThing || row.tempThingFor) && row.devices == null
//                             ? "orange"
//                             : row.devices === null
//                               ? "grey"
//                               : "green",
//                       }}
//                     >
//                       {(row.tempThing || row.tempThingFor) && row.devices === null
//                         ? "Disabled"
//                         : row.devices === null
//                           ? "No device"
//                           : "Enabled"}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Typography variant="body2">{row.tempThing || ""}</Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Typography variant="body2">
//                       {row.tempThing && things.find((e) => e.thingId === row.tempThing)
//                         ? things.find((e) => e.thingId === row.tempThing).nickName
//                         : ""}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Typography
//                       variant="body2"
//                       component="a"
//                       sx={{ cursor: "pointer", color: row.tempThing ? "orange" : "blue", textDecoration: "none" }}
//                       onClick={() => handleAssingnVehicle(row)}
//                     >
//                       {row.tempThing ? "Remove Replacement" : "Assign Replacement"}
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ))
//             ) : (
//               <TableRow>
//                 <TableCell colSpan={6} align="center">
//                   <Typography variant="body2" color="text.secondary">
//                     No records found
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* FILTER POPOVER */}
//       <Popover
//         open={open}
//         anchorEl={anchorEl}
//         onClose={() => setAnchorEl(null)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         transformOrigin={{ vertical: "top", horizontal: "center" }}
//         PaperProps={{
//           sx: { backgroundColor: "#ffffff", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", borderRadius: "6px" },
//         }}
//       >
//         <MDBox p={2} minWidth={180}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={deviceFilter.enabled}
//                 onChange={(e) => setDeviceFilter({ ...deviceFilter, enabled: e.target.checked })}
//               />
//             }
//             label="Enabled"
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={deviceFilter.disabled}
//                 onChange={(e) => setDeviceFilter({ ...deviceFilter, disabled: e.target.checked })}
//               />
//             }
//             label="Disabled"
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={deviceFilter.noDevice}
//                 onChange={(e) => setDeviceFilter({ ...deviceFilter, noDevice: e.target.checked })}
//               />
//             }
//             label="No device"
//           />
//           <MDBox display="flex" justifyContent="flex-end" gap={1} mt={1}>
//             <Button size="small" onClick={() => setAnchorEl(null)}>OK</Button>
//             <Button size="small" onClick={() => setDeviceFilter({ enabled: false, disabled: false, noDevice: false })}>
//               Reset
//             </Button>
//           </MDBox>
//         </MDBox>
//       </Popover>
//     </Paper>
//   );
// }

// export default PlanningTable;
import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Popover,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MDBox from "components/MDBox";
import { useDispatch, useSelector } from "react-redux";
import { fetchThingDetails } from "features/thing/thingThunk";
import {
  setModelThing,
  setModalVisible,
  setCheckData,
} from "features/planning/planningSlice";

function PlanningTable() {
  const dispatch = useDispatch();

  const things = useSelector((state) => state.things.things);
  const modalVisible = useSelector((state) => state.planning.modalVisible);

  // filter popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [deviceFilter, setDeviceFilter] = useState({
    enabled: false,
    disabled: false,
    noDevice: false,
  });

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  // Assign / Remove replacement
  // If the clicked row is itself a replacement vehicle (tempThingFor is set),
  // operate on the ORIGINAL vehicle's record so "Remove Replacement" works from either row.
  const handleAssingnVehicle = (val) => {
    const target = val.tempThingFor
      ? things.find((e) => e.thingId === val.tempThingFor) || val
      : val;

    dispatch(setCheckData(Boolean(target.tempThing)));
    dispatch(setModalVisible(true));
    dispatch(setModelThing(target));
  };

  // Sorting Handler
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // FILTERED DATA
  const filteredThings = things.filter((row) => {
    if (!deviceFilter.enabled && !deviceFilter.disabled && !deviceFilter.noDevice) {
      return true;
    }

    const status =
      (row.tempThing || row.tempThingFor) && row.devices === null
        ? "disabled"
        : row.devices === null
          ? "noDevice"
          : "enabled";

    if (deviceFilter.enabled && status === "enabled") return true;
    if (deviceFilter.disabled && status === "disabled") return true;
    if (deviceFilter.noDevice && status === "noDevice") return true;

    return false;
  });

  // SORTED DATA
  const sortedAndFilteredThings = [...filteredThings].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const valA = a[sortConfig.key] ? a[sortConfig.key].toString().toLowerCase() : "";
    const valB = b[sortConfig.key] ? b[sortConfig.key].toString().toLowerCase() : "";

    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // Custom Icon Renderer function
  const renderSortIcons = (columnKey) => {
    const isActive = sortConfig.key === columnKey;
    const isAsc = isActive && sortConfig.direction === "asc";
    const isDesc = isActive && sortConfig.direction === "desc";

    return (
      <Box
        onClick={() => handleSort(columnKey)}
        sx={{
          display: "flex",
          flexDirection: "column",
          ml: 0.5,
          cursor: "pointer",
        }}
      >
        <ArrowDropUpIcon
          sx={{
            fontSize: 20,
            mb: -1.3,
            color: isAsc ? "#1976d2" : "#c4c4c4",
            transition: "color 0.2s",
          }}
        />
        <ArrowDropDownIcon
          sx={{
            fontSize: 20,
            color: isDesc ? "#1976d2" : "#c4c4c4",
            transition: "color 0.2s",
          }}
        />
      </Box>
    );
  };

  return (
    <Paper
      sx={{
        mx: "auto",
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <TableContainer>
        <Table>
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
                <Box display="flex" alignItems="center">
                  VEHICLE NO.
                  {renderSortIcons("thingId")}
                </Box>
              </TableCell>

              <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
                <Box display="flex" alignItems="center">
                  VEHICLE NAME
                  {renderSortIcons("nickName")}
                </Box>
              </TableCell>

              <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
                <MDBox display="flex" alignItems="center">
                  DEVICE STATUS
                  <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </MDBox>
              </TableCell>

              <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
                REPLACED VEHICLE NO.
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>
                REPLACED VEHICLE NAME
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>ACTION</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {sortedAndFilteredThings.length > 0 ? (
              sortedAndFilteredThings.map((row, idx) => {
                // Either this row has a replacement (tempThing),
                // or this row IS a replacement for another vehicle (tempThingFor)
                const hasReplacement = Boolean(row.tempThing || row.tempThingFor);
                const relatedId = row.tempThing || row.tempThingFor || "";
                const relatedThing = relatedId
                  ? things.find((e) => e.thingId === relatedId)
                  : null;

                return (
                  <TableRow
                    key={row.thingId ?? idx}
                    sx={{ "&:hover": { backgroundColor: "#fafafa" }, transition: "all 0.2s ease" }}
                  >
                    <TableCell>
                      <Typography variant="body2">{row.thingId}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{row.nickName}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          color: hasReplacement && row.devices == null
                            ? "orange"
                            : row.devices === null
                              ? "grey"
                              : "green",
                        }}
                      >
                        {hasReplacement && row.devices === null
                          ? "Disabled"
                          : row.devices === null
                            ? "No device"
                            : "Enabled"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{relatedId}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {relatedThing ? relatedThing.nickName : ""}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        component="a"
                        sx={{
                          cursor: "pointer",
                          color: hasReplacement ? "orange" : "blue",
                          textDecoration: "none",
                        }}
                        onClick={() => handleAssingnVehicle(row)}
                      >
                        {hasReplacement ? "Remove Replacement" : "Assign Replacement"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="body2" color="text.secondary">
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* FILTER POPOVER */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "6px",
          },
        }}
      >
        <MDBox p={2} minWidth={180}>
          <FormControlLabel
            control={
              <Checkbox
                checked={deviceFilter.enabled}
                onChange={(e) => setDeviceFilter({ ...deviceFilter, enabled: e.target.checked })}
              />
            }
            label="Enabled"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={deviceFilter.disabled}
                onChange={(e) => setDeviceFilter({ ...deviceFilter, disabled: e.target.checked })}
              />
            }
            label="Disabled"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={deviceFilter.noDevice}
                onChange={(e) => setDeviceFilter({ ...deviceFilter, noDevice: e.target.checked })}
              />
            }
            label="No device"
          />
          <MDBox display="flex" justifyContent="flex-end" gap={1} mt={1}>
            <Button size="small" onClick={() => setAnchorEl(null)}>
              OK
            </Button>
            <Button
              size="small"
              onClick={() => setDeviceFilter({ enabled: false, disabled: false, noDevice: false })}
            >
              Reset
            </Button>
          </MDBox>
        </MDBox>
      </Popover>
    </Paper>
  );
}


export default PlanningTable;